<template>
  <TrainerLayout>
    <div class="px-4">
      <nav class="mt-8 mb-6" aria-label="breadcrumb">
        <ol
          class="flex leading-none text-gray-dark divide-x-1 divide-gray-darkest"
        >
          <li class="pr-4">
            <button
              type="button"
              :class="step == 1 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(1)"
            >
              Class Pack Info
              <span class="text-red-700">
                {{
                  $v.title.$error ||
                  $v.language.$error ||
                  $v.category_id.$error ||
                  $v.difficulty_type.$error ||
                  $v.description.$error
                    ? "*"
                    : ""
                }}
              </span>
            </button>
          </li>
          <li class="px-4">
            <button
              type="button"
              :class="step == 4 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(4)"
            >
              Pricing Info
              <span class="text-red-700">
                {{ $v.cost.$error ? "*" : "" }}
              </span>
            </button>
          </li>
          <li class="px-4">
            <button
              type="button"
              :class="step == 2 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(2)"
            >
              Featured Image
              <span class="text-red-700">
                {{ showAlertCircleIcon == false ? "*" : "" }}
              </span>
            </button>
          </li>
          <li class="px-4">
            <button
              type="button"
              :class="step == 3 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(3)"
            >
              Supporting Images
              <span class="text-red-700">
                {{ isSupportingImageValid == false ? "*" : "" }}
              </span>
            </button>
          </li>
          <li class="px-4">
            <button
              type="button"
              :class="step == 5 ? 'text-green-light' : 'text-gray-dark'"
              @click="onclickSelectStep(5)"
            >
              Class Info
              <span class="text-red-700">
                {{ isStepThreeNextButtonClicked == false ? "*" : "" }}
              </span>
            </button>
          </li>
        </ol>
        <div class="text-red-700" v-if="!$v.sessionName.minLength">
          Class list must have at least
          {{ $v.sessionName.$params.minLength.min }} elements.
        </div>
        <div class="text-red-700" v-else-if="!$v.sessionName.required">
          Class list must not be empty.
        </div>
        <div class="text-red-700" v-else-if="$v.sessionName.$error">
          <!-- Class list is invalid. -->
          Please fill details of all classes
        </div>
        <ul class="text-red-700">
          <!-- $v.$anyError -->
          <li v-if="$v.$error">
            <strong>Form has <kbd>error</kbd>.</strong>
          </li>
        </ul>
      </nav>
      <form @submit.prevent="handleCourseSubmit" enctype="multipart/form-data">
        <!-- && paramId == null -->
        <template v-if="step == 1">
          <!-- <h3 class="text-lg capitalize mb-4">Edit Course</h3> -->
          <div
            class="mb-4 text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">Class Pack Name </label>
              <input
                type="text"
                class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                :class="{ 'ring-red-700': $v.title.$error }"
                v-model="$v.title.$model"
                placeholder="Enter Class Pack Name"
              />
              <div v-if="$v.title.$error">
                <span class="text-red-700 text-xs" v-if="!$v.title.required">
                  Course Name field is required
                </span>
              </div>
            </div>

            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required"> Language </label>
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                :class="{ 'border-red-700': $v.language.$error }"
                v-model="$v.language.$model"
              >
                <option value="">Select</option>
                <option :value="l.id" v-for="l in languagesList" :key="l.id">
                  {{ l.language }}
                </option>
              </select>
              <div v-if="$v.language.$error">
                <span class="text-red-700 text-xs" v-if="!$v.language.required">
                  Language field is required
                </span>
              </div>
            </div>
          </div>

          <div
            class="mb-4 text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">Course Category </label>
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                :class="{ 'border-red-700': $v.category_id.$error }"
                v-model="$v.category_id.$model"
              >
                <option value="">Select</option>
                <option :value="c.id" v-for="c in categoriesList" :key="c.id">
                  {{ c.name }}
                </option>
              </select>
              <div v-if="$v.category_id.$error">
                <span class="text-red-700" v-if="!$v.category_id.required">
                  Course Category field is required
                </span>
              </div>
            </div>

            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">Difficulty </label>
              <select
                class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                :class="{ 'border-red-700': $v.difficulty_type.$error }"
                v-model="$v.difficulty_type.$model"
              >
                <option value="">Select</option>
                <option :value="d.id" v-for="d in difficultiesList" :key="d.id">
                  {{ d.level }}
                </option>
              </select>
              <div v-if="$v.difficulty_type.$error">
                <span class="text-red-700" v-if="!$v.difficulty_type.required">
                  Difficulty field is required
                </span>
              </div>
            </div>
          </div>

          <div class="mb-4 text-gray-700">
            <label class="block mb-1">Tags </label>
            <InputTag
              v-model="tags"
              :add-tag-on-keys="tagsOnKeys"
              class="rounded-lg flex items-center"
            ></InputTag>
            <div v-if="$v.tags.$error">
              <span class="text-xs text-red-700">
                Special Characters lke [-,?@!<>&] in Tags are not allowed
              </span>
            </div>
          </div>

          <div class="mb-4 text-gray-700">
            <label class="block mb-1 required">Description </label>
            <textarea
              class="block w-full h-24 text-gray-slate p-3 border-1 border-borderColor focus:outline-none rounded-md"
              :class="{ 'ring-red-700': $v.description.$error }"
              v-model="$v.description.$model"
              placeholder="Add your Class description here"
            ></textarea>
            <div v-if="$v.description.$error">
              <p class="text-red-700 text-xs" v-if="!$v.description.required">
                Description field is required
              </p>
            </div>
          </div>

          <!-- <div class="mb-4 text-gray-700">
            <label class="block">Duration </label>
            <div
              class="text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
            >
              <div class="w-full px-2 md:w-1/2">
                <label class="block mb-1 required">Hours</label>
                @change="handleDuration"
                <select
                  class="form-select outline-none mt-1 block hover:shadow-lg w-full p-2 ring-1 ring-gray-500 rounded-lg"
                  v-model="$v.duration_hours.$model"
                  :class="{ 'border-red-700': $v.duration_hours.$error }"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in DURATION_HOURS"
                    :key="item.id"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>
              <div class="w-full px-2 md:w-1/2">
                <label class="block mb-1 required">Minutes</label>
                @change="handleDuration"
                <select
                  class="form-select outline-none mt-1 hover:shadow-lg block w-full ring-1 p-2 ring-gray-500 rounded-lg"
                  v-model="$v.duration_mins.$model"
                  :class="{ 'border-red-700': $v.duration_mins.$error }"
                >
                  <option value="">Select</option>
                  <option
                    v-for="item in DURATION_MINS"
                    :key="item.id"
                    :value="item"
                  >
                    {{ item }}
                  </option>
                </select>
              </div>
            </div>
            <div v-if="$v.duration.$error">
              <span class="text-red-700 text-xs" v-if="!$v.duration.required">
                Duration field is required
              </span>
              <span class="text-red-700 text-xs" v-if="!$v.duration.numeric">
                Accepts only numerics.
              </span>
              <span class="text-red-700 text-xs" v-if="!$v.duration.between">
                Duration must be between 30 minutes to 12 hours.
              </span>
            </div>
          </div> -->
        </template>
        <!-- || paramId == 2 -->
        <template v-if="step == 2">
          <!-- <h3 class="text-lg uppercase">Images</h3> -->
          <CourseImages
            v-on:thumbnail-image="handleThumbnailImage"
            v-on:supporting-image="handleSupportingImage"
            v-on:remove-supporting-image="removeSupportingImage"
            v-on:thumbnail-id="thumbnailId"
            :supportingImages="supportingImage"
            :details="
              trainerCourseView &&
              trainerCourseView.course &&
              trainerCourseView.course.details
            "
            :categoryId="category_text"
            :src="thumbnailImage"
            @handleFileProps="handleFileMethod"
            :isSupportingImageValid="isSupportingImageValid"
            :showAlertCircleIcon="showAlertCircleIcon"
          />
        </template>
        <!-- && paramId == null -->
        <template v-if="step == 3">
          <CourseSupportingImages
            v-on:supporting-image="handleSupportingImage"
            :supportingImages="
              trainerCourseView && trainerCourseView.supporting_images
            "
            :details="
              trainerCourseView &&
              trainerCourseView.course &&
              trainerCourseView.course.details
            "
            :categoryId="category_text"
            :src="thumbnailImage"
            :courseCreate="true"
            :isSupportingImageValid="isSupportingImageValid"
            :showAlertCircleIcon="showAlertCircleIcon"
          />
        </template>

        <template v-if="step == 4">
          <!-- <h3 class="text-lg uppercase">Room Settings</h3> -->
          <label class="block mb-1 required"> Cost of Course </label>
          <div class="mb-4 text-gray-700 relative">
            <input
              type="text"
              class="w-full text-gray-slate pl-8 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
              :class="{ 'ring-red-700': $v.cost.$error }"
              v-model="$v.cost.$model"
            />
            <div
              class="absolute inset-y-0 left-0 flex items-center px-2 pointer-events-none"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-dollar-sign"
              >
                <line x1="12" y1="1" x2="12" y2="23"></line>
                <path
                  d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"
                ></path>
              </svg>
            </div>
            <div v-if="$v.cost.$error">
              <span class="text-red-700 text-xs" v-if="!$v.cost.required">
                Cost of Course field is required
              </span>
              <span class="text-xs text-red-700" v-if="!$v.cost.numeric">
                Accepts only numerics.
              </span>
            </div>
          </div>

          <!-- <div
            class="text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
          >
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">
                Room Size
                <span class="text-xs capitalize">(total Attendees)</span>
              </label>
              <select
                class="form-select outline-none mt-1 hover:shadow-lg block w-full p-2 ring-1 ring-gray-500 rounded-lg"
                :class="{ 'border-red-700': $v.roomSize.$error }"
                v-model="$v.roomSize.$model"
              >
                <option value="">Select</option>
                <option v-for="item in ROOMSIZE" :key="item.id" :value="item">
                  {{ item }}
                </option>
              </select>
              <div v-if="$v.roomSize.$error">
                <span class="text-red-700 text-xs" v-if="!$v.roomSize.required">
                  Room Size field is required
                </span>
              </div>
            </div>
            <div class="w-full px-2 md:w-1/2">
              <label class="block mb-1 required">Webcams Allowed </label>
              <select
                class="form-select outline-none mt-1 hover:shadow-lg block w-full p-2 ring-1 ring-gray-500 rounded-lg"
                v-model="$v.totalWebcamAllowed.$model"
                :class="{
                  'border-red-700': $v.totalWebcamAllowed.$error,
                }"
              >
                <option value="">Select</option>
                <option v-for="item in ROOMSIZE" :key="item.id" :value="item">
                  {{ item }}
                </option>
              </select>
              <div v-if="$v.totalWebcamAllowed.$error">
                <span
                  class="text-red-700 text-xs"
                  v-if="!$v.totalWebcamAllowed.required"
                >
                  Webcams Allowed field is required
                </span>
              </div>
              <span class="text-red-700" v-if="limit">
                Webcams cannot be more than room size
              </span>
            </div>
          </div> -->
        </template>

        <template v-if="step == 5">
          <span v-if="validationMessage" class="text-red-700 text-xs"
            >Please fill details of all classes</span
          >
          <ul class="flex border-b mb-4">
            <li
              class="-mb-px mr-1 minWidthFitContent"
              v-for="step in sessionStep"
              :key="step.id"
            >
              <button
                type="button"
                :class="{
                  'inline-block py-2 px-2 bg-white text-green-light hover:text-green-dark font-semibold focus:outline-none':
                    step != currentStep,
                  'rounded-l-lg text-white bg-green-light inline-block py-2 px-2 font-semibold hover:text-white-700 focus:outline-none':
                    step == currentStep,
                }"
                @click="handleSessionClick(step)"
              >
                Class {{ step }}
              </button>
              <button
                type="button"
                :class="{
                  'inline-block py-2 px-2 bg-white text-green-light hover:text-green-dark font-semibold focus:outline-none':
                    step != currentStep,
                  'rounded-r-lg text-white bg-green-light inline-block py-2 px-2 font-semibold hover:text-white-700 focus:outline-none':
                    step == currentStep,
                }"
                title="Remove Session"
                @click="handleSessionDel(step)"
              >
                x
              </button>
            </li>
            <li class="mr-1 minWidthFitContent">
              <button
                type="button"
                class="bg-white inline-block py-2 px-4 text-green-light hover:text-green-dark font-semibold focus:outline-none"
                title="Add Session"
                @click="handleAddClick"
              >
                Add +
              </button>
            </li>
          </ul>
          <ul>
            <li v-for="step in sessionStep" :key="step.id">
              <div class="md:flex" v-if="step == currentStep">
                <div class="md:w-1/2 pr-2">
                  <div class="mb-4 text-gray-700">
                    <label class="block mb-1 required">Class Name</label>
                    <input
                      type="text"
                      class="w-full text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                      :class="{
                        'ring-red-700':
                          !$v.sessionName.required &&
                          isStepThreeNextButtonClicked,
                      }"
                      v-model="sessionName[currentStep - 1].title"
                      placeholder="Name of the Class"
                    />
                    <span
                      class="text-red-700 text-xs"
                      v-if="
                        !$v.sessionName.required && isStepThreeNextButtonClicked
                      "
                    >
                      Class Name field is required
                    </span>
                    <span
                      class="text-red-700 text-xs"
                      v-if="
                        !$v.sessionName.maxLength &&
                        isStepThreeNextButtonClicked
                      "
                    >
                      Class Name must have at most 100 letters.
                    </span>
                  </div>

                  <div class="mb-4 text-gray-700">
                    <label class="block mb-1 required">Description</label>
                    <textarea
                      class="w-full text-gray-slate pl-3 pr-3 pt-2 pb-2 h-24 border-1 border-borderColor focus:outline-none rounded-md"
                      :class="{
                        'ring-red-700':
                          !$v.sessionDescription.required &&
                          isStepThreeNextButtonClicked,
                      }"
                      v-model="sessionDescription[currentStep - 1].description"
                      placeholder="Add your session description here"
                    ></textarea>
                    <span
                      class="text-red-700 text-xs"
                      v-if="
                        !$v.sessionDescription.required &&
                        isStepThreeNextButtonClicked
                      "
                    >
                      Description field is required
                    </span>
                  </div>

                  <div class="mb-4 text-gray-700">
                    <label class="block"> Duration </label>
                    <div
                      class="text-gray-700 flex flex-wrap -mx-2 space-y-4 md:space-y-0"
                    >
                      <div class="w-full px-2 md:w-1/2">
                        <label class="block mb-1 required">Hours</label>
                        <select
                          class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                          :class="{
                            'ring-red-700':
                              !$v.sessionDurationHours.required &&
                              isStepThreeNextButtonClicked,
                          }"
                          v-model="sessionDurationHours[currentStep - 1].hours"
                        >
                          <option value="">Select</option>
                          <option
                            v-for="item in DURATION_HOURS"
                            :key="item.id"
                            :value="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                      <div class="w-full px-2 md:w-1/2">
                        <label class="block mb-1 required">Minutes</label>
                        <select
                          class="block w-full form-select text-gray-slate pl-3 pr-3 h-10 md:h-12 border-1 border-borderColor focus:outline-none rounded-md"
                          :class="{
                            'ring-red-700':
                              !$v.sessionDurationMins.required &&
                              isStepThreeNextButtonClicked,
                          }"
                          v-model="sessionDurationMins[currentStep - 1].mins"
                        >
                          <option value="">Select</option>
                          <option
                            v-for="item in DURATION_MINS"
                            :key="item.id"
                            :value="item"
                          >
                            {{ item }}
                          </option>
                        </select>
                      </div>
                    </div>
                    <span
                      class="text-red-700 text-xs"
                      v-if="
                        !$v.sessionDurationHours.required &&
                        isStepThreeNextButtonClicked
                      "
                    >
                      Duration field is required
                    </span>
                  </div>

                  <div class="mb-4 text-gray-700">
                    <label class="block mb-1 required">Class Thumbnail</label>
                    <!-- <input
                      type="file"
                      class="w-full h-10 px-3 text-base py-1 placeholder-gray-600 ring-1 ring-gray-500 rounded-lg focus:outline-none capitalize"
                      :class="{
                        'ring-red-700':
                          !$v.sessionImage.required &&
                          isStepThreeNextButtonClicked,
                      }"
                      @change="handleSessionChange"
                    /> -->
                    <button
                      type="button"
                      class="h-8 px-5 my-2 text-indigo-100 transition-colors duration-150 bg-green-light rounded-lg focus:shadow-outline hover:bg-green-light ring-1"
                      :class="{
                        'ring-red-700':
                          !$v.courseSessionImageObj.required &&
                          isStepThreeNextButtonClicked,
                      }"
                      @click="onclickChoosefile"
                    >
                      Choose file
                    </button>
                    <span
                      class="text-red-700 text-xs"
                      v-if="
                        !$v.courseSessionImageObj.required &&
                        isStepThreeNextButtonClicked
                      "
                    >
                      Class Thumbnail field is required
                    </span>
                    <ThumbnailModal
                      v-if="isModalOpen"
                      :tabSelection="'library'"
                      :isModalOpenProp="isModalOpen"
                      @sessionImage="createSessionImage"
                      @cancelModal="onclickChoosefile"
                    />
                  </div>
                </div>
                <div class="md:w-1/2 pl-2 pt-8">
                  <section class="rounded">
                    <div
                      v-if="
                        courseSessionImageObj &&
                        courseSessionImageObj.length > 0
                      "
                    >
                      <Cropper
                        ref="cropper"
                        class="twitter-cropper"
                        background-class="twitter-cropper__background"
                        foreground-class="twitter-cropper__foreground"
                        image-restriction="stencil"
                        default-boundaries="fill"
                        :stencil-size="stencilSize"
                        :stencil-props="{
                          handlers: {},
                          movable: false,
                          scalable: false,
                          aspectRatio: 5 / 3, // 1
                          previewClass: 'twitter-cropper__stencil',
                        }"
                        :transitions="false"
                        :canvas="true"
                        :debounce="false"
                        :default-size="defaultSize"
                        :min-width="150"
                        :min-height="150"
                        :src="
                          courseSessionImageObj[currentStep - 1] &&
                          courseSessionImageObj[currentStep - 1].result
                        "
                        @change="onChange"
                      />
                      <Navigation
                        :zoom="zoom"
                        @change="onZoom"
                        @zoomInBtn="zoomIn"
                        @zoomOutBtn="zoomOut"
                      />
                    </div>
                    <div v-else>
                      <div
                        class="bg-gray-100 h-80 w-90 rounded-md flex justify-center items-center border"
                      >
                        <img
                          class="rounded-md h-20 w-20 object-cover"
                          src=""
                          alt=""
                          onerror="this.style.display='none'"
                        />
                      </div>
                      <Navigation
                        :zoom="zoom"
                        @change="onZoom"
                        @zoomInBtn="zoomIn"
                        @zoomOutBtn="zoomOut"
                      />
                    </div>
                  </section>
                </div>
              </div>
            </li>
          </ul>
        </template>

        <div class="inline-flex mt-3 mb-3 float-right">
          <!-- v-if="step == 1" -->
          <router-link
            :to="{ name: 'sessions', params: { id: 'all' } }"
            class="inline-flex items-center h-10 w-24 px-4 m-2 text-green-light transition-colors duration-150 ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
          >
            Cancel
          </router-link>
          <!-- <button
            type="button"
            class="inline-flex items-center h-10 w-24 px-4 m-2 text-green-light ring-green-light ring-1 rounded-lg focus:outline-none hover:bg-green-light hover:text-white"
            v-if="(step == 2 || step == 3 || step == 4) && paramId == null"
            @click.prevent="handlePrevClick"
          >
            Previous
          </button> -->
          <!-- <button
            type="button"
            class="h-10 w-24 px-4 m-2 text-green-100 transition-colors duration-150 ring-green-light bg-green-light rounded-lg focus:outline-none ring-1 hover:shadow-lg"
            @click.prevent="handleNextClick"
            v-if="(step == 1 || step == 2 || step == 4) && paramId == null"
          >
            Next
          </button> -->
          <!-- v-if="step == 3 || paramId == 2"
            @click="handleStep(paramId)" -->
          <button
            type="submit"
            class="h-10 w-24 px-4 m-2 text-green-100 ring-green-light transition-colors duration-150 rounded-lg focus:outline-none ring-1 bg-green-light hover:shadow-lg"
          >
            Finish
          </button>
        </div>
      </form>
    </div>
  </TrainerLayout>
</template>

<script>
import TrainerLayout from "@/components/layouts/TrainerLayout.vue";
import CourseImages from "@/components/CourseImages";
import CourseSupportingImages from "@/components/CourseSupportingImages";
import InputTag from "vue-input-tag";
import { Cropper } from "vue-advanced-cropper";
import Navigation from "@/components/cropper/Navigation";
import {
  between,
  maxLength,
  numeric,
  required,
  minLength,
} from "vuelidate/lib/validators";
import ThumbnailModal from "@/components/modals/ThumbnailModal.vue";
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  name: "CreateEdit",
  components: {
    TrainerLayout,
    CourseImages,
    CourseSupportingImages,
    InputTag,
    Cropper,
    Navigation,
    ThumbnailModal,
  },

  data() {
    return {
      step: 1,
      id: "",
      title: "",
      language: "",
      category_id: "",
      difficulty_type: "",
      tags: [],
      description: "",
      // courseImage: "",
      thumbnailImage: "",
      thumbnail_url: "",
      currentStep: 1,
      finalStep: 2,
      sessionId: [],
      sessionName: [],
      duration: 1,
      sessionDescription: [],
      sessionDurationHours: [],
      sessionDurationMins: [],
      courseSessionImageObj: [],
      // duration_hours: "",
      // duration_mins: 0,
      cost: 0,
      roomSize: 200,
      totalWebcamAllowed: 25,
      category_text: "",
      isSupportingImageValid: true,
      // limit: false,
      supportingImage: [],
      showAlertCircleIcon: true,
      zoom: 0,
      isStepThreeNextButtonClicked: false,
      thumbnail_id: "",
      // paramId: null,
      validationMessage: false,
      sessionStep: [], //1, 2, 3
      isModalOpen: false,
    };
  },

  validations: {
    title: {
      required,
    },
    language: {
      required,
    },
    tags: {
      validTagsArr: (tags) => {
        const regex = /[!@#$%^&*(),.?":{}|<>\-]/;
        return !tags.some((tag) => regex.test(tag));
      }
    },
    category_id: {
      required,
    },
    difficulty_type: {
      required,
    },
    description: {
      required,
    },
    thumbnailImage: {
      required,
    },
    sessionName: {
      required,
      // maxLength: maxLength(100),
      minLength: minLength(2),
      $each: {
        title: {
          required,
          minLength: minLength(2),
        },
      },
    },
    sessionDescription: {
      required,
      minLength: minLength(2),
      $each: {
        description: {
          required,
          minLength: minLength(2),
        },
      },
    },
    sessionDurationHours: {
      required,
      minLength: minLength(2),
      $each: {
        hours: {
          required,
        },
      },
    },
    sessionDurationMins: {
      required,
      minLength: minLength(2),
      $each: {
        mins: {
          required,
        },
      },
    },
    courseSessionImageObj: {
      required,
      minLength: minLength(2),
      $each: {
        result: {
          required,
        },
      },
    },
    cost: {
      required,
      numeric,
    },
    // duration: {
    //   required,
    //   between: between(30, 720),
    //   numeric,
    // },
    // duration_hours: {
    //   required,
    // },
    // duration_mins: {
    //   required,
    // },
    // roomSize: {
    //   required,
    // },
    // totalWebcamAllowed: {
    //   required,
    // },
    supportingImage: {
      required,
      minLength: minLength(2),
    },
  },
  computed: {
    ...mapGetters([
      "trainerCourseView",
      "languagesList",
      "categoriesList",
      "difficultiesList",
    ]),
  },
  methods: {
    ...mapActions([
      "trainerCourseUpdate",
      "getTrainerCourseView",
      "getLanguagesList",
      "getCategoriesList",
      "getDifficultiesList",
    ]),

    handleNextClick() {
      // this.$v.$touch();
      // if (this.step == 1) {
      this.$v.title.$touch();
      this.$v.language.$touch();
      this.$v.tags.$touch();
      this.$v.category_id.$touch();
      this.$v.difficulty_type.$touch();
      this.$v.description.$touch();
      if (
        this.$v.title.$invalid ||
        this.$v.language.$invalid ||
        this.$v.category_id.$invalid ||
        this.$v.difficulty_type.$invalid ||
        this.$v.description.$invalid ||
        this.$v.tags.$invalid
      ) {
        console.log("invalid");
        this.step = 1;
        return false;
      } else {
        this.step = 4;
      }
      // } else if (this.step == 2) {
      // if (!this.courseImage) {
      //   this.courseImage = this.thumbnailImage;
      // }
      this.$v.thumbnailImage.$touch();
      if (this.$v.thumbnailImage.$invalid) {
        console.log("invalid");
        this.showAlertCircleIcon = false;
        this.step = 2;
        return false;
      } else {
        this.showAlertCircleIcon = true;
        this.step = 3;
      }
      // } else if (this.step == 3) {
      this.$v.supportingImage.$touch();
      if (this.$v.supportingImage.$invalid) {
        console.log("invalid");
        this.isSupportingImageValid = false;
        this.step = 3;
        return false;
      } else {
        this.isSupportingImageValid = true;
        this.step = 5;
      }
      // } else if (this.step == 5) {
      this.$v.sessionName.$touch();
      this.$v.sessionDescription.$touch();
      this.$v.sessionDurationHours.$touch();
      this.$v.sessionDurationMins.$touch();
      this.$v.courseSessionImageObj.$touch();
      if (
        this.$v.sessionName.$invalid ||
        this.$v.sessionDescription.$invalid ||
        this.$v.sessionDurationHours.$invalid ||
        this.$v.sessionDurationMins.$invalid ||
        this.$v.courseSessionImageObj.$invalid
      ) {
        console.log("invalid");
        this.isStepThreeNextButtonClicked = false;
        this.step = 5;
        return false;
      } else {
        this.isStepThreeNextButtonClicked = true;
      }
      for (var i = 0; i < this.sessionStep.length; i++) {
        if (this.sessionName[i] == (undefined || "")) {
          this.validationMessage = true;
          console.log("invalid");
          return false;
        }
        if (this.sessionDescription[i] == (undefined || "")) {
          this.validationMessage = true;
          console.log("invalid");
          return false;
        }
        if (this.sessionDurationHours[i] == (undefined || "")) {
          this.validationMessage = true;
          console.log("invalid");
          return false;
        }
        if (this.sessionDurationMins[i] == (undefined || "")) {
          this.validationMessage = true;
          console.log("invalid");
          return false;
        }
        if (this.courseSessionImageObj[i] == undefined || "") {
          this.validationMessage = true;
          this.currentStep = this.finalStep;
          console.log("invalid");
          return false;
        }
      }
      // }
      // } else if (this.step == 4) {
      if (this.$v.cost.$invalid) {
        console.log("invalid");
        this.step = 4;
        return false;
      } else {
        this.step = 2;
      }
      // } else {
      //   this.step++;
      // }
    },

    // handleStep() {
    //   if (this.paramId == 2) {
    //     if (!this.courseImage) {
    //       this.courseImage = this.thumbnailImage;
    //     }
    //     this.$v.supportingImage.$touch();
    //     if (this.$v.courseImage.$invalid || this.$v.supportingImage.$invalid) {
    //       if (this.$v.supportingImage.$invalid) {
    //         this.isSupportingImageValid = false;
    //       }
    //       if (this.$v.thumbnailImage.$invalid) {
    //         this.showAlertCircleIcon = false;
    //       }
    //       console.log("invalid");
    //       return;
    //     }
    //   }
    // },

    // handlePrevClick() {
    //   this.step--;
    // },

    async createSessionImage(file) {
      // this.sessionImage.push(file);
      if (/\.(jpe?g|png|gif)$/i.test(file.name)) {
        var reader = new FileReader();

        reader.onload = (e) => {
          // this.courseSessionImageObj.push(e.target.result);
          var obj = {
            id: this.currentStep,
            file: file,
            result: e.target.result,
          };
          this.createOrUpdateMethod(obj);
        };
        reader.readAsDataURL(file);
      } else {
        let newfile = await fetch(file)
          .then((r) => r.blob())
          .then((blob) => new File([blob], "filename", { type: "image/png" }));
        var newreader = new FileReader();

        newreader.onload = (e) => {
          var obj = {
            id: this.currentStep,
            file: newfile,
            result: e.target.result,
          };
          this.createOrUpdateMethod(obj);
        };
        newreader.readAsDataURL(newfile);
      }
    },

    createOrUpdateMethod(obj) {
      var index = this.courseSessionImageObj.findIndex(
        (u) => u.id == this.currentStep
      );
      if (index === -1) {
        this.courseSessionImageObj.push(obj);
      } else {
        this.courseSessionImageObj.splice(index, 1);
        this.courseSessionImageObj.push(obj);
      }
    },

    handleFileMethod(value) {
      this.thumbnailImage = value;
    },

    handleAddClick() {
      // if (this.step == 2) {
      //   if (this.$v.sessionName.$invalid) {
      //     return false;
      //   }
      //   if (this.$v.duration.$invalid) {
      //     return false;
      //   }
      //   if (this.$v.sessionDescription.$invalid) {
      //     return false;
      //   }
      //   if (this.$v.sessionImage.$invalid) {
      //     return false;
      //   }
      // }
      this.sessionName.push({ title: "" });
      this.sessionDescription.push({ description: "" });
      this.sessionDurationHours.push({ hours: "" });
      this.sessionDurationMins.push({ mins: "" });
      this.finalStep++;
      this.sessionStep.push(this.finalStep);
      this.currentStep = this.finalStep;
    },

    handleSessionClick(step) {
      this.currentStep = step;
    },

    handleSessionDel(step) {
      this.finalStep = step - 1;
      this.sessionStep.splice(step - 1);
      this.currentStep = step - 1;
    },

    // handleDuration() {
    //   this.$v.duration_hours.$touch();
    //   this.$v.duration_mins.$touch();
    //   this.$v.duration.$model =
    //     this.$v.duration_mins.$model + 60 * this.$v.duration_hours.$model;
    // },

    handleCourseSubmit() {
      this.$v.$touch();
      // this.$v.totalWebcamAllowed.$touch();
      // this.$v.roomSize.$touch();
      // if (this.$v.totalWebcamAllowed.$model > this.$v.roomSize.$model) {
      //   this.limit = true;
      //   return false;
      // }
      if (this.$v.$invalid) {
        console.log("invalid");
        this.handleNextClick();
      } else {
        let data = new FormData();
        data.append("id", this.id);
        data.append("title", this.title);
        data.append("language", this.language);
        data.append("category_id", this.category_id);
        data.append("difficulty_type", this.difficulty_type);
        data.append("tags", this.tags && this.tags.toString());
        data.append("description", this.description);
        data.append("thumbnail_url", this.thumbnailImage);
        data.append("thumbnail_image", this.thumbnailImage);
        data.append("unsplash_image_id", this.thumbnail_id);
        data.append("duration", this.duration);
        data.append("cost", this.cost);
        data.append("room_size", this.roomSize);
        data.append("total_webcam_allowed", this.totalWebcamAllowed);
        for (var i = 0; i < this.supportingImage.length; i++) {
          data.append("supporting_image[" + i + "]", this.supportingImage[i]);
        }
        for (var j = 0; j < this.sessionStep.length; j++) {
          if (this.sessionId[j] !== undefined) {
            data.append("sessions[" + j + "][id]", this.sessionId[j]);
          }
          if (this.sessionName[j] !== undefined) {
            data.append(
              "sessions[" + j + "][title]",
              this.sessionName[j].title
            );
          }
          if (this.sessionDescription[j] !== undefined) {
            data.append(
              "sessions[" + j + "][description]",
              this.sessionDescription[j].description
            );
          }
          if (this.sessionDurationHours[j] !== undefined) {
            data.append(
              "sessions[" + j + "][duration]",
              this.sessionDurationMins[j].mins +
                60 * this.sessionDurationHours[j].hours
            );
          }
          if (this.courseSessionImageObj[j] !== undefined) {
            data.append(
              "sessions[" + j + "][thumbnail_image]",
              this.courseSessionImageObj[j].file
            );
          }
        }
        this.trainerCourseUpdate(data)
          .then(() => {
            this.$router.push({ name: "course" });
          })
          .catch(() => {});
      }
    },

    handleThumbnailImage(value) {
      this.thumbnailImage = value;
    },

    handleSupportingImage(val) {
      // if (val.length > 1) {
      //   let i = 0;
      //   while (i < val.length - 1) {
      //     this.supportingImage.pop();
      //     i++;
      //   }
      // }
      // for (let i = 0; i < val.length; i++) {
      //   this.supportingImage.push(val[i]);
      // }
      this.supportingImage = val;
    },
    removeSupportingImage(val) {
      this.supportingImage = val;
    },

    // blobToFile(blob) {
    //   return new File([blob], `my_image${new Date()}.jpeg`);
    // },

    onChange() {
      const cropper = this.$refs.cropper[0];
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          this.zoom =
            (cropper.imageSize.height - cropper.coordinates.height) /
            (cropper.imageSize.height - cropper.sizeRestrictions.minHeight);
        } else {
          this.zoom =
            (cropper.imageSize.width - cropper.coordinates.width) /
            (cropper.imageSize.width - cropper.sizeRestrictions.minWidth);
        }
      }
      const { canvas } = cropper.getResult();
      if (canvas) {
        canvas.toBlob((blob) => {
          // this.courseSessionImageObj[this.currentStep] = this.blobToFile(blob);
        }, "image/jpeg");
      } else {
        console.log("canvas is not defined");
      }
    },

    // cropper stencil-size
    stencilSize({ boundaries }) {
      return {
        width: Math.min(boundaries.height, boundaries.width) - 48,
        height: Math.min(boundaries.height, boundaries.width) - 48,
      };
    },

    // cropper default-size
    defaultSize({ imageSize }) {
      return {
        width: Math.min(imageSize.height, imageSize.width),
        height: Math.min(imageSize.height, imageSize.width),
      };
    },

    onZoom(value) {
      const cropper = this.$refs.cropper[0];
      if (cropper) {
        if (cropper.imageSize.height < cropper.imageSize.width) {
          const minHeight = cropper.sizeRestrictions.minHeight;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.height + minHeight) /
              ((1 - value) * cropper.imageSize.height + minHeight)
          );
        } else {
          const minWidth = cropper.sizeRestrictions.minWidth;
          cropper.zoom(
            ((1 - this.zoom) * cropper.imageSize.width + minWidth) /
              ((1 - value) * cropper.imageSize.width + minWidth)
          );
        }
      }
    },

    zoomIn(value) {
      value += 0.011;

      this.onZoom(value);
    },

    zoomOut(value) {
      value -= 0.011;

      this.onZoom(value);
    },

    handleCategoryChange(event) {
      this.category_text =
        event.target.options[event.target.options.selectedIndex].text;
    },
    thumbnailId(val) {
      this.thumbnail_id = val;
    },

    onclickChoosefile() {
      this.isModalOpen = !this.isModalOpen;
    },

    onclickSelectStep(val) {
      this.step = val;
    },
  },
  async created() {
    this.getLanguagesList();
    this.getCategoriesList();
    this.getDifficultiesList();
    await this.getTrainerCourseView({ id: this.$route.params.id });
    this.id = this.trainerCourseView.course.details[0].id;
    this.title = this.trainerCourseView.course.details[0].title;
    this.language = this.trainerCourseView.course.details[0].language;
    this.category_id = this.trainerCourseView.course.details[0].category_id;
    this.category_text = this.trainerCourseView.course.details[0].category_name;
    this.difficulty_type = this.trainerCourseView.course.details[0].difficulty_type;
    this.tags =
      (this.trainerCourseView.course.details[0] &&
        this.trainerCourseView.course.details[0].tags &&
        this.trainerCourseView.course.details[0].tags.split(",")) ||
      [];
    this.category_text = this.trainerCourseView.course.details[0].category_name;
    this.description = this.trainerCourseView.course.details[0].description;
    this.thumbnail_url = this.trainerCourseView.course.details[0].thumbnail_url;
    this.cost = this.trainerCourseView.course.details[0].cost;
    // this.duration = this.trainerCourseView.course.details[0].duration;
    // this.roomSize = this.trainerCourseView.course.details[0].room_size;
    // this.totalWebcamAllowed = this.trainerCourseView.course.details[0].total_webcam_allowed;
    this.supportingImage =
      this.trainerCourseView && this.trainerCourseView.supporting_images;
    // let duration_hour_min = this.hourToMinConverter(
    //   this.trainerCourseView.course.details[0].duration
    // ).split(":");
    // this.$v.duration_hours.$model = duration_hour_min[0];
    // this.$v.duration_mins.$model = duration_hour_min[1];
    this.trainerCourseView &&
      this.trainerCourseView.sessions.forEach(async (el, i) => {
        if (el.id) {
          this.sessionStep.push(i + 1);
          this.finalStep = i + 1;
          this.sessionId.push(el.id);
        }
        if (el.title) {
          this.sessionName.push({ title: el.title });
        }
        if (el.description) {
          this.sessionDescription.push({ description: el.description });
        }
        if (el.duration) {
          let duration_hour_min = this.hourToMinConverter(el.duration).split(
            ":"
          );
          this.sessionDurationHours.push({ hours: duration_hour_min[0] });
          this.sessionDurationMins.push({ mins: 0 });
        }
        if (el.thumbnail_url) {
          await axios
            .post("image-blob", {
              image_url: el.thumbnail_url,
            })
            .then((res) => {
              fetch(res.data.data.content)
                .then((response) => response.blob())
                .then((blob) => {
                  let file = new File([blob], "filename", {
                    type: blob.type,
                  });
                  this.courseSessionImageObj.push({
                    id: i + 1,
                    file: file,
                    result: res.data.data.content,
                  });
                });
            })
            .catch((e) => console.log(e));
        }
      });
    //Converting the url to file type to remove supporting image error
    for (let i = 0; i < this.supportingImage.length; i++) {
      await axios
        .post("image-blob", {
          image_url: this.supportingImage[i].thumbnail_url,
        })
        .then((res) => {
          fetch(res.data.data.content)
            .then((response) => response.blob())
            .then((blob) => {
              let file = new File([blob], "filename", {
                type: blob.type,
              });
              this.supportingImage[i] = file;
            });
        })
        .catch((e) => console.log(e));
    }
    await axios
      .post("image-blob", {
        image_url: this.thumbnail_url,
      })
      .then((res) => {
        fetch(res.data.data.content)
          .then((response) => response.blob())
          .then((blob) => {
            let file = new File([blob], "filename", {
              type: blob.type,
            });
            this.thumbnailImage = file;
            this.thumbnail_url = file;
          });
      })
      .catch((e) => console.log(e));
    // this.paramId = (await this.$route.query) && this.$route.query.step;
  },
};
</script>